var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{attrs:{"clearable":"","filterable":"","change-on-select":_vm.changeOnSelect,"value":_vm.localValue,"placeholder":_vm.placeholder,"data":_vm.addressList,"load-data":_vm.loadList,"disabled":_vm.disabled},on:{"on-change":_vm.change}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f82ab97c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressSelect.vue
// module id = null
// module chunks = 